<template>
  <Page>
    <template #right>
      <van-count-down
        ref="countDown"
        :time="time"
        format="sss"
        @finish="countdownfinish"
      />
    </template>
    <div class="code-search">
        <van-cell-group inset>
            <van-field v-model="code" placeholder="请输入单号后5位" />
        </van-cell-group>
        <van-button type="primary" size="large" @click="submit" :disabled="code.length < 5">查询</van-button>
    </div>
  </Page>
</template>

<script>
import { getByCode } from "@/apis/index";
// import cellInput from "@/components/cellInput";
import { mapState } from "vuex";
import { mobileReg } from "@/utils/validate";
import { playVoice } from "@/utils";
import { Toast } from 'vant';

export default {
  components: {
    // cellInput
  },
  data() {
    return {
        code: "",
      form: {
        secret: ""
      },
      showKeyboard: true,
      focusKey: "phone",
      time: 120 * 1000
    };
  },
  mounted() {
    // setTimeout(() => this.playTips(), 2000);
  },
  computed: {
    ...mapState(["stationInfo"])
  },
  methods: {
    countdownfinish() {
      this.$router.push("/");
    },
    async submit() {
        if(this.code.length !== 5) {
            Toast.fail('请输入5位单号');
            return;
        }
        Toast.loading('查询中...');
        const res = await getByCode(this.code);
        Toast.clear();
        if(res && res.length > 0) {
            const pk = res[0];
            this.$router.push({
                path: "/user/pick-list",
                query: {
                    secret: pk.secret,
                }
            });
        } else {
            Toast.fail('没有数据');
        }
    }
  }
};
</script>

<style lang="scss">
.code-search {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    gap: rem(30);
    padding: 0 15%;
    background-color: #f4f4f4;
    .van-cell-group {
        background-color: transparent;
    }
    .van-field {
        font-size: rem(80);
        font-weight: 500;
        border: 2px solid #d9d9d9;
        border-radius: rem(20);
        padding: rem(30);
        box-shadow: 0px 0px 13px 3px rgba(0, 0, 0, 0.1);
        input {
            text-align: center;
        }
    }
    .van-button {
        height: rem(80);
        font-size: rem(40);
    }
}
</style>
